module.exports = __webpack_public_path__ + "6dc90063.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/src/src_img/nav_logo@2x.png
// module id = 1202
// module chunks = 0